import { useParams } from 'react-router-dom';

import { useCarrierContractSuspenseQuery } from '../queries';
import { Page } from './page';

export function DuplicatePage() {
  const { id } = useParams();
  const { data: contract } = useCarrierContractSuspenseQuery({ contract_id: id });

  return <Page defaultValues={{ ...contract, name: contract.name! }} />;
}
